import Settings from '../components/views/Settings'
import Portals from '../components/views/Portals'
import Portal from '../components/views/portals/Add'
import route from './route'

export default [
  route('/settings', Settings, 'settings.index'),
  // route('/portals', Portals, 'portals.index'),

  route('/:scope/Portal/add', Portal, 'portal.add'),
  route('/:scope/Portal/:item/edit', Portal, 'portal.edit')
  // route('/:scope/Orders/:item/edit', Order, 'orders.edit')
]
